import React, { Fragment, useState, useEffect } from "react";
import { Loader } from "./Loader";
import {Header} from './Header'
import {Footer} from './Footer'
export function Testimony() {

const [data3, enterData3] = useState(true);

useEffect(() => {
  setTimeout(() => {
    enterData3(false);
  }, 2500);
}, []);

  return (
    <Fragment>
       <div className="inner">
      <Header/>
      {data3 && <Loader />}
      <h1 style={{ textAlign: "center" }}>Testimonial</h1>
      <br />
      <blockquote>
        <img
          src="images/user-01.jpg"
          alt="Mr Emma Onah"
          style={{
            borderRadius: 100,
            display: "flex",
            alignItems: "center",
            margin: "auto",
          }}
          height={80}
          width={80}
        />
        <h6 style={{ textAlign: "center" }}>
          <strong>Emmanuel Isegbo Onah</strong>
          <br />{" "}
          <span style={{ fontSize: 9 }}>FCVMLT, NVRI, Vom-Jos, Nigeria</span>
        </h6>
        My site <a href="https://isegbeonah.com" target="__blank">www.isegbeonah.com</a> was designed
        and hosted by Promise shedrach. He offers one of the best and affordable
        solutions in website designing, development, and management. If you seek
        web services, I strongly recommend his service.
      </blockquote>
      <br />
      <br />
      </div>
      <Footer/>
    </Fragment>
  );
}
